import * as net from "../vipa/net";

export class Case {
    constructor() {
        $("#cart").on("click", "#cart-send-order", this.submit);
        $("#cart").on("click", "#cart-send-quote", this.submit);
        $("#cart").on("change", "#cart-destination", this.change);
        $("#cart").on("change", "#cart-yourReference", this.change);
        $("#cart").on("change", "#cart-note", this.change);
    }

    change = (event: JQuery.ChangeEvent) => {
        this.save();
    }

    submit = (event: JQuery.ClickEvent) => {
        this.save();
        return confirm(event.target.getAttribute("data-confirm-message"));
    }

    save = () => {
        let destination_code = $("#cart-destination").val();
        let note = $("#cart-note").val();
        let your_reference = $("#cart-yourReference").val();
        let data = {
            jsonrpc: "2.0",
            id: null,
            destination_code: destination_code,
            note: note,
            your_reference: your_reference
        }
        let url;
        if (globalThis.lang) {
            url = `/${globalThis.lang}/j/update-cart/`;
        } else {
            url = "/j/update-cart/";
        }
        net.postJSON(url, data, this.clickSuccess.bind(this))
            .fail(this.clickFail);
    }

    clickSuccess(response: JQuery.PlainObject): void {
        $("#cart-updated").show().delay(1000).fadeOut("slow");
    }

    clickFail(response: JQuery.jqXHR): void {
        let modal = $("#modal-small");
        let content = $("#modal-small div");

        content.html(response.responseJSON.error);
        modal.foundation("open");
    }
}
